import { Component } from '@angular/core';

@Component({
  selector: 'app-un-authorised',
  templateUrl: './un-authorised.component.html',
  styleUrls: ['./un-authorised.component.scss'],
})
export class UnAuthorisedComponent {}
